import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Image,
  Dimensions,
  TextInput,
  ScrollView,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import SettingsStyleSheet from '../../StyleSheets/SettingStyleSheet';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-rte';
import {AppToast} from '../../HelperClasses/AppToast';
import networkService from '../../Network/NetworkManager';
import {addMixpanelEvent, MixpanelEvent} from '../../Models/MixPannelEnum';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import SidePanView from '../../Component/SidePanView';
import SaveButton from '../../Component/SaveButton';
import SecondryButton from '../../Component/SecondryButton';
import ToolTipViewBtn from '../../Component/ToolTipViewBtn';
import AppConstantsMessage from '../../Constants/AppConstantsMessage';
import {RestrictedFeatureEnum} from '../../Models/RestrictedFeatureEnum';
import SubscribePlan from '../../Component/SubscribePlan';
import TableCommonStyleSheet from '../../StyleSheets/TableCommonStyleSheet';
import LanguageSwitch from '../../Component/LanguageSwitch';

const AppConstants = require('../../Constants/AppConstants');
const APPURL = require('../../Constants/URLConstants');
//'Subscription', 'Subscription Receipt'
const titleArray = [
  'Welcome Message Template',
  'OTP Message Template',
  'Subscription Link Template',
  'Subscription Success Template',
  'Order Buyer Email Template',
  'Order Seller Email Template',
];
const mergeTags = [
  '{first_name} {last_name}',
  '{first_name} {last_name} {code}',
  '{first_name} {last_name} {link}',
  '{first_name} {last_name} {product_name} {amount} {manage_link}',
  '{app_color_primary}, {business_name}, {business_logo}, {business_address}, {order_creation_date}, {order_reference_number}, {delivery_address}, {#each order_items}, {order_listing_title}, {order_listing_quantity}, {order_listing_price}, {/each order_items}, {#each pricing_items}, {order_pricing_name}, {order_pricing_amount}, {/each pricing_items}, {order_grand_total}',
  '{app_color_primary}, {business_name}, {business_logo}, {business_address}, {order_creation_date}, {order_reference_number}, {delivery_address}, {#each order_items}, {order_listing_title}, {order_listing_quantity}, {order_listing_price}, {total_earnings},{/each order_items}, {#each pricing_items}, {order_pricing_name}, {order_pricing_amount}, {/each pricing_items}, {order_grand_total}',
];

const KeyGroup = 'email';
const keysTitleArray = [
  'welcome_email_title',
  'verification_email_title',
  'subscription_email_subject_template',
  'subscription_success_email_subject_template',
  'buyer_order_placed_email_subject',
  'seller_order_received_email_subject',
];
const keysBodyArray = [
  'welcome_email_body_template',
  'verification_email_body_template',
  'subscription_email_body_template',
  'subscription_success_email_body_template',
  'order_buyer_email_template',
  'order_seller_email_template',
];

const downloadTemplate = [
  '',
  '',
  '',
  '',
  'https://media.tradly.app/others/templates/email/buyer_order_placed_email_template.html',
  'https://media.tradly.app/others/templates/email/seller_order_placed_email_template.html',
];

const windowHeight = Dimensions.get('window').height;

export default class EditEmailNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subMenuSelectedIndex: 0,
      statusArray: [false, false, false, false],
      updateUI: false,
      bodyValue: '',
      showEditor: this.props.showEditor,
      editorIndex: 0,
      subjectTitle: '',
      dataLoad: false,
      configData: {},
      emailTest: '',
      showUpgrade: false,
      selectedLanguage: '',
      defaultLanguage: '',
      languages: [],
      translations: {},
    };
  }
  static propTypes = {
    backBtn: PropTypes.func,
    success: PropTypes.func,
    editEmail: PropTypes.func,
    showEditor: PropTypes.bool,
    languages: PropTypes.array,
  };
  componentDidMount() {
    this.loadConfigApi();
    this.loadLanguageApi();
  }
  //MARK:-  APIs Method 
  loadConfigApi = async (selectedLanguage = null) => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=' + KeyGroup,
      'get',
      '',
      '',
      '',
      selectedLanguage ? selectedLanguage : null,
    );
    this.setState({currencyArray: []});
    if (responseJson['status'] == true) {
      this.state.configData = responseJson['data']['configs'];
      if (selectedLanguage && selectedLanguage != this.state.defaultLanguage) {
        this.state.translations[selectedLanguage] = {
          subject:
            this.state.configData[keysTitleArray[this.props.editorIndex]] ?? '',
          body:
            this.state.configData[keysBodyArray[this.props.editorIndex]] ?? '',
        };
      } else {
        this.state.subjectTitle =
          this.state.configData[keysTitleArray[this.props.editorIndex]] ?? '';
        this.state.bodyValue =
          this.state.configData[keysBodyArray[this.props.editorIndex]] ?? '';
      }
    }
    this.setState({dataLoad: true});
  };

  loadLanguageApi = async () => {
    this.setState({dataLoad: false});

    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.tanantslanguage,
      'get',
      '',
      '',
    );
    if (responseJson['status'] == true) {
      var ppData = responseJson['data']['languages'];
      this.setState({languages: ppData});
    }

    this.setState({dataLoad: true});
  };

  updateTranslation = (field, value, languageCode) => {
    this.setState(prevState => ({
      translations: {
        ...prevState.translations,
        [languageCode]: {
          ...prevState.translations[languageCode],
          [field]: value,
        },
      },
    }));
  };

  addOrUpdateApi = async () => {
    this.setState({dataLoad: false});

    var configs = [];
    if (this.state.bodyValue.length != 0) {
      let fDict = {
        key_group: KeyGroup,
        key: keysBodyArray[this.props.editorIndex],
        value: this.state.bodyValue,
        secured: false,
      };
      configs.push(fDict);
    }
    if (this.state.subjectTitle.length != 0) {
      let fDict = {
        key_group: KeyGroup,
        key: keysTitleArray[this.props.editorIndex],
        value: this.state.subjectTitle,
        secured: false,
      };
      configs.push(fDict);
    }

    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,
      'post',
      JSON.stringify({configs: configs}),
    );

    if (responseJson['status'] == true) {
      if (Object.keys(this.state.translations).length > 0) {
        const translationConfigs = [];

        Object.entries(this.state.translations).forEach(
          ([langCode, values]) => {
            if (values.body) {
              translationConfigs.push({
                key_group: KeyGroup,
                key: keysBodyArray[this.props.editorIndex],
                value: values.body,
                locale: langCode,
              });
            }
            if (values.subject) {
              translationConfigs.push({
                key_group: KeyGroup,
                key: keysTitleArray[this.props.editorIndex],
                value: values.subject,
                locale: langCode,
              });
            }
          },
        );

        if (translationConfigs.length > 0) {
          await networkService.networkCall(
            APPURL.URLPaths.configsTranslations,
            'post',
            JSON.stringify({configs: translationConfigs}),
          );
        }
      }

      addMixpanelEvent(MixpanelEvent.emailNotification, {success: true});
      AppToast();
      this.props.success(true);
    } else {
      addMixpanelEvent(MixpanelEvent.emailNotification, {success: false});
      this.setState({dataLoad: true});
      this.props.success(false);
    }
  };
  resetToDefaultApi = async () => {
    this.setState({dataLoad: false});
    let urlParm =
      APPURL.URLPaths.config +
      '?key=' +
      `${keysBodyArray[this.props.editorIndex]},${
        keysTitleArray[this.props.editorIndex]
      }`;
    const responseDeleteJson = await networkService.networkCall(
      urlParm,
      'delete',
      '',
      '',
    );

    if (responseDeleteJson['status'] == true) {
      addMixpanelEvent(MixpanelEvent.emailNotification, {success: true});
      AppToast();
      this.props.success(true);
    } else {
      addMixpanelEvent(MixpanelEvent.emailNotification, {success: false});
      this.setState({dataLoad: true});
      this.props.success(false);
    }
  };

  downloadTemplateApi = async () => {
    window.open(downloadTemplate[this.props.editorIndex], '_blank');
  };
  testEmailApi = async () => {
    this.setState({dataLoad: false});
    let emailAry = this.state.emailTest.split(',');
    let fDict = {
      subject: this.state.subjectTitle,
      body: this.state.bodyValue,
      email: emailAry,
    };
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.testEmail,
      'post',
      JSON.stringify(fDict),
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      addMixpanelEvent(MixpanelEvent.emailNotificationTest, {success: true});
      AppToast(undefined, 'Sent');
    } else {
      addMixpanelEvent(MixpanelEvent.emailNotificationTest, {success: false});
      this.setState({dataLoad: true});
      AppToast(responseJson);
    }
  };
  checkRestriction() {
    let check_access = AppConstants.accessControl?.[
      AppConstants.plan_name
    ]?.includes(RestrictedFeatureEnum.customizeEmailTemplates);
    return check_access;
  }
  //MARK:-  Buttons Action Method 
  submitButtonAction() {
    let bodyValue = this.state.bodyValue;
    if (this.state.subjectTitle.length == 0) {
      AppToast('Subject should not be empty');
    } else if (bodyValue.length == 11) {
      AppToast('body should not be empty');
    } else {
      if (this.props.editorIndex == 1) {
        if (bodyValue.includes('{code}')) {
          this.addOrUpdateApi();
        } else {
          AppToast('{code} merge tag is mandatory');
        }
      } else {
        this.addOrUpdateApi();
      }
    }
  }
  sendTestBtnAction() {
    if (this.state.emailTest.length != 0) {
      this.testEmailApi();
    }
  }
  renderSaveConfigBtn = () => {
    return (
      <View style={{flexDirection: 'row'}}>
        <SaveButton
          saveBtn={() => this.submitButtonAction()}
          saveBtnTitle={'Update'}
          btnDeActive={this.checkRestriction()}
          deActiveBtnAction={() => this.setState({showUpgrade: true})}
          showLock={true}
        />
      </View>
    );
  };
  renderSecondaryButtons = () => {
    return (
      <View style={{flexDirection: 'row'}}>
        {downloadTemplate[this.props.editorIndex] !== '' && (
          <SecondryButton
            btnAction={() => this.downloadTemplateApi()}
            btnTitle={'Download Template'}
          />
        )}
        <SecondryButton
          btnAction={() => this.resetToDefaultApi()}
          btnTitle={'Reset to default'}
        />
      </View>
    );
  };

  renderModelView = () => {
    return (
      <View style={{height: '100%'}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
            alignItems: 'center',
          }}>
          <View style={CommonStyleSheet.sidepanSaveBtnViewStyle}>
            {this.renderSecondaryButtons()}
          </View>
          <View style={CommonStyleSheet.sidepanSaveBtnViewStyle}>
            {this.renderSaveConfigBtn()}
          </View>
        </div>
        <View style={styles.modalViewStyle}>
          <View>
            <LanguageSwitch
              selectedLanguage={this.state.selectedLanguage}
              setSelectedLanguage={lang => {
                this.setState({selectedLanguage: lang});
                this.loadConfigApi(lang);
              }}
              setDefaultLanguage={lang => {
                this.setState({defaultLanguage: lang});
              }}
              languages={this.state.languages || []}
            />
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>Subject Line</Text>
              <TextInput
                style={[appConfigStyle.txtFieldStyle, {outline: 0}]}
                value={
                  this.state.selectedLanguage === this.state.defaultLanguage
                    ? this.state.subjectTitle
                    : this.state.translations[this.state.selectedLanguage]
                        ?.subject || ''
                }
                placeholder="Enter the Subject"
                placeholderTextColor={colors.placeholderColor}
                onChangeText={subject => {
                  if (
                    this.state.selectedLanguage === this.state.defaultLanguage
                  ) {
                    this.setState({subjectTitle: subject});
                  } else {
                    this.updateTranslation(
                      'subject',
                      subject,
                      this.state.selectedLanguage,
                    );
                  }
                }}
              />
            </View>
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                Available merge tags:
                <Text style={CommonStyleSheet.plainSubTextStyle}>
                  {`  `}
                  {mergeTags[this.props.editorIndex]}
                </Text>
              </Text>
            </View>
            <View style={{marginTop: 20}}>
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <Text style={appConfigStyle.titleTxtStyle}>Body</Text>
                <ToolTipViewBtn
                  title={AppConstantsMessage.email_body}
                  description={AppConstantsMessage.email_body_info}
                />
              </View>
              <TextInput
                style={[
                  appConfigStyle.descriptionTxtFieldStyle,
                  {outline: 0, height: windowHeight / 3},
                ]}
                placeholder="Write here..."
                placeholderTextColor={colors.placeholderColor}
                value={
                  this.state.selectedLanguage === this.state.defaultLanguage
                    ? this.state.bodyValue
                    : this.state.translations[this.state.selectedLanguage]
                        ?.body || ''
                }
                onChangeText={body => {
                  if (
                    this.state.selectedLanguage === this.state.defaultLanguage
                  ) {
                    this.setState({bodyValue: body});
                  } else {
                    this.updateTranslation(
                      'body',
                      body,
                      this.state.selectedLanguage,
                    );
                  }
                }}
                multiline={true}
              />
            </View>
            <View style={{marginTop: 20, flex: 1}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                Enter test emails
              </Text>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <TextInput
                  style={[
                    appConfigStyle.txtFieldStyle,
                    {outline: 0, width: '100%'},
                  ]}
                  value={this.state.emailTest}
                  placeholder="Enter multiple emails with comma"
                  placeholderTextColor={colors.placeholderColor}
                  onChangeText={subject => this.setState({emailTest: subject})}
                />
                <View
                  style={{
                    marginLeft: 20,
                    height: 40,
                    marginTop: 20,
                    marginRight: -10,
                  }}>
                  <SecondryButton
                    btnTitle={'Send test'}
                    btnAction={() => this.sendTestBtnAction()}
                  />
                </View>
              </View>
            </View>
            {/* <BuyerOrderMailMergeTags /> */}
          </View>
        </View>
        <Appload enable={this.state.dataLoad} />
      </View>
    );
  };

  renderUpgradePlanView() {
    return (
      <TouchableOpacity
        style={[
          TableCommonStyleSheet.passwordViewStyle,
          {display: this.state.showUpgrade ? 'flex' : 'none'},
        ]}
        onPress={() => this.setState({showUpgrade: false})}>
        <SubscribePlan upgrade={true} />
      </TouchableOpacity>
    );
  }

  render() {
    return (
      <View>
        <View style={{zIndex: 101}}>{this.renderUpgradePlanView()}</View>
        <this.renderModelView />
      </View>
    );
  }
}
const styles = StyleSheet.create({
  modalViewStyle: {
    // backgroundColor: colors.AppWhite,
    // position: 'absolute',
    // borderColor: colors.SimonGray,
    // borderWidth: 1,
    margin: 10,
    // borderRadius: 10,
    // padding: 10,
    // width: '100%',
  },
});
